import { DefaultSeoProps } from 'next-seo';

const site_name = 'GraphCMS';
const title = 'GraphCMS';
const description = `GraphCMS is the next generation GraphQL-Native Headless CMS. Create and access content on any platform. Start building API-first & for free!`;
export const defaultSeoUrl = 'https://graphcms.com';

export const defaultSeo: DefaultSeoProps = {
  defaultTitle: site_name,
  title,
  description,
  openGraph: {
    description,
    title,
    type: 'website',
    url: defaultSeoUrl,
    site_name,
  },
  twitter: {
    handle: '@GraphCMS',
    site: '@GraphCMS',
    cardType: 'summary_large_image',
  },
  additionalMetaTags: [
    {
      property: 'theme-color',
      content: '#6563FD',
    },
    {
      property: 'msapplication-TileColor',
      content: '#6563FD',
    },
    {
      property: 'referrer',
      content: 'no-referrer-when-downgrade',
    },
    {
      property: 'HandheldFriendly',
      content: 'True',
    },
    {
      property: 'MobileOptimized',
      content: '360',
    },
    {
      httpEquiv: 'x-ua-compatible',
      content: 'IE=edge,chrome=1',
    },
  ],
  additionalLinkTags: [
    {
      rel: 'sitemap',
      type: 'application/xml',
      href: '/sitemap.xml',
    },
    {
      rel: 'manifest',
      href: '/manifest.webmanifest',
    },
    {
      rel: 'apple-touch-icon',
      href: '/icons/icon-48x48.png',
      sizes: '48x48',
    },
    {
      rel: 'apple-touch-icon',
      href: '/icons/icon-72x72.png',
      sizes: '72x72',
    },
    {
      rel: 'apple-touch-icon',
      href: '/icons/icon-96x96.png',
      sizes: '96x96',
    },
    {
      rel: 'apple-touch-icon',
      href: '/icons/icon-144x144.png',
      sizes: '144x144',
    },
    {
      rel: 'apple-touch-icon',
      href: '/icons/icon-192x192.png',
      sizes: '192x192',
    },
    {
      rel: 'apple-touch-icon',
      href: '/icons/icon-256x256.png',
      sizes: '256x256',
    },
    {
      rel: 'apple-touch-icon',
      href: '/icons/icon-384x384.png',
      sizes: '384x384',
    },
    {
      rel: 'apple-touch-icon',
      href: '/icons/icon-512x512.png',
      sizes: '512x512',
    },
  ],
};
